import React from 'react'
import classnames from 'classnames';
import { ChromePicker } from 'react-color';

import Dropdown from 'Components/dropdown';
import { __, sprintf } from 'StylistParent/i18n';

/* Import CSS */
import './style.scss';

class ColorPalette extends React.Component {

	converToRGBAObject = ( color ) => {
		let rgbaArray

		if ( color.includes( "rgba" ) ) {
			// Break-down RGBA color.
			let colorValues = color.replace( "rgba(", "" )
			colorValues = colorValues.replace( ")", "" )
			rgbaArray = colorValues.split( "," )
		} else {
			// Convert non-RGBA color to RGBA format.
			var pub = {}, canvas, context;
			canvas = document.createElement('canvas');
			canvas.height = 1;
			canvas.width = 1;
			context = canvas.getContext('2d');

			/**
			 * Turns any valid canvas fillStyle into a 4-element Uint8ClampedArray with bytes
			 * for R, G, B, and A. Invalid styles will return [0, 0, 0, 0]. Examples:
			 * color_convert.to_rgb_array('red')  # [255, 0, 0, 255]
			 * color_convert.to_rgb_array('#ff0000')  # [255, 0, 0, 255]
			 * color_convert.to_rgb_array('garbagey')  # [0, 0, 0, 0]
			 */
			// Setting an invalid fillStyle leaves this unchanged
			context.fillStyle = 'rgba(0, 0, 0, 0)';
			// We're reusing the canvas, so fill it with something predictable
			context.clearRect(0, 0, 1, 1);
			context.fillStyle = color;
			context.fillRect(0, 0, 1, 1);

			rgbaArray = context.getImageData(0, 0, 1, 1).data;
		}

		// Transform array [RR,GG,BB,AA] into object{r:XX,g:XX,b:XX,a:XX}
		const rgbaObj = {
			r: rgbaArray[0],
			g: rgbaArray[1],
			b: rgbaArray[2],
			a: rgbaArray[3]
		}
		return rgbaObj
	}

	toggleColor = (event) => {
		event.preventDefault();
		this.props.changeValue(event.target.value)
	}

	colorChanged = ( color ) => {
		color = `rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})`
		this.props.changeValue(color)
	}

	render() {
		const { colors, currentValue, onChange } = this.props;

		let valueRGBA = ''
		if ( 'string' === typeof this.props.currentValue ) {
			valueRGBA = this.converToRGBAObject( this.props.currentValue );
		}

		return (
			<div className="blocks-color-palette">
				{ colors.map( ( color ) => {
					const style = { color: color };

					let currentValueUpper = ''
					if ( 'string' === typeof currentValue ) {
						currentValueUpper = currentValue.toUpperCase()
					}

					if ( undefined !== color ) {
						color = color.toUpperCase()
					}
					const className = classnames( 'blocks-color-palette__item', { 'is-active': currentValueUpper === color } );

					return (
						<div key={ color } className="blocks-color-palette__item-wrapper">
							<button
								type="button"
								className={ className }
								style={ style }
								value={ color }
								onClick={ this.toggleColor }
								aria-label={ sprintf( __( 'Color: %s' ), color ) }
								aria-pressed={currentValue === color }
							/>
						</div>
					);
				} ) }

				<Dropdown
					className="blocks-color-palette__item-wrapper blocks-color-palette__custom-color"
					contentClassName="blocks-color-palette__picker "
					renderToggle={ ( { isOpen, onToggle } ) => (
						<button
							type="button"
							aria-expanded={ isOpen }
							className="blocks-color-palette__item"
							onClick={ onToggle }
							aria-label={ __( 'Custom color picker' ) }
						>
							<span className="blocks-color-palette__custom-color-gradient" />
						</button>
					) }
					renderContent={ () => (
						<ChromePicker
							color={ valueRGBA }
							onChange={ (color) => this.colorChanged( color ) }
							// onChangeComplete={ (color) => this.colorChanged( color ) }
							style={ { width: '100%' } }
						/>
					) }
				/>

				<div className="blocks-color-palette__item-wrapper blocks-color-palette__clear-color">
					<button
						className="blocks-color-palette__item"
						value="inherit"
						onClick={this.toggleColor}
						aria-label={ __( 'Remove color' ) }
					>
						<span className="blocks-color-palette__clear-color-line" />
					</button>
				</div>
			</div>
		)
	}
}

export default ColorPalette



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/color-palette/index.js